import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import DetailRow from '../components/DetailRow'
import { formatIsoDate } from '../../schedule/lib/format'
import type { CostApplication } from '../types'

const DASH = '—'

interface Props { application: CostApplication; projectId: string }

const ApplicationSummaryCard: React.FC<Props> = ({ application: a, projectId }) => {
  const { t } = useTranslation()
  const base = `/project/${projectId}/cost-control`
  const when = (name: string | null, at: string | null) => (at ? `${name ?? DASH} · ${new Date(at).toLocaleString(t('date_locale') || 'cs-CZ')}` : DASH)
  return (
    <Card className="border-0 shadow-sm">
      <CardHeader><CardTitle className="text-base">{t('CostControl_application_details_title')}</CardTitle></CardHeader>
      <CardContent>
        <dl className="divide-y">
          <DetailRow label={t('CostControl_invoice_field_contract')}>
            <Link className="text-primary hover:underline" to={`${base}/contracts/${a.contractId}`}>{a.contractNumber ? `${a.contractNumber} · ${a.contractName}` : a.contractName}</Link>
          </DetailRow>
          <DetailRow label={t('CostControl_application_field_period')}>{formatIsoDate(t, a.periodFrom)} – {formatIsoDate(t, a.periodTo)}</DetailRow>
          {a.returnNote && a.status === 'DRAFT' && <DetailRow label={t('CostControl_application_field_returnNote')}><span className="whitespace-pre-wrap text-destructive">{a.returnNote}</span></DetailRow>}
          <DetailRow label={t('CostControl_application_field_submitted')}>{when(a.submittedByName, a.submittedAt)}</DetailRow>
          <DetailRow label={t('CostControl_application_field_certified')}>{when(a.certifiedByName, a.certifiedAt)}</DetailRow>
          <DetailRow label={t('CostControl_invoice_field_number')}>
            {a.invoiceId ? <Link className="text-primary hover:underline" to={`${base}/invoices/${a.invoiceId}`}>{a.invoiceNumber}</Link> : (a.investorInvoice?.number ?? DASH)}
          </DetailRow>
          <DetailRow label={t('CostControl_application_field_note')}><span className="whitespace-pre-wrap">{a.note || DASH}</span></DetailRow>
        </dl>
      </CardContent>
    </Card>
  )
}
export default ApplicationSummaryCard
